import { WorkspacePermissionsAdapter } from '@xometry/workspace';
import useCurrentUserPermissions from 'utils/hooks/useCurrentUserPermissions';

import { useAllowedToUpdatePresets } from './useAllowedToUpdatePresets';

/** ERP's role/permission model for the Workspace library. */
export const erpPermissionsAdapter: WorkspacePermissionsAdapter = {
  useCurrentUserPermissions: () => {
    const { allPermissions, loading } = useCurrentUserPermissions();

    // ERP restricts access, so no permissions after loading (failed or skipped query) mean none, not "unrestricted".
    return { allPermissions: allPermissions ?? (loading ? undefined : {}), loading };
  },
  useCanManagePresets: useAllowedToUpdatePresets,
};
